// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__31Os_","content":"GlobalSearch_content__3_7Hf"};